import helpers from 'utils/helpers';

// response of proposal PATCHs
const proposal = ({ stepName, data }) => {
  const entitiesMapper = {
    cpf: {
      enrichedLeadToken: data?.data?.['lead-token'],
      enrichedLeadTokenExp: data?.data?.['valid-time'],
      nextStep: data?.['next-step'],
      nextPage: data?.['next-page'],
      flowName: data?.['flow-name'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      journeyID: data?.['journey-identifier'],
    },
    nome: {
      nextStep: data?.['next-step'],
      prevStep: data?.['prev-step'],
      flowName: data?.['flow-name'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
    },
    email: {
      nextStep: data?.['next-step'],
      prevStep: data?.['prev-step'],
      flowName: data?.['flow-name'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
    },
    celular: {
      nextStep: data?.['next-step'],
      prevStep: data?.['prev-step'],
      flowName: data?.['flow-name'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
    },
    otp: {
      nextStep: data?.['next-step'],
      prevStep: data?.['prev-step'],
      flowName: data?.['flow-name'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
    },
  };

  return entitiesMapper?.[stepName];
};

// response of proposal GETs
const getProposal = ({ stepName, data }) => {
  const entitiesMapper = {
    cpf: {
      documentNumber: data?.data?.['document-number'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      flowName: data?.['flow-name'],
      leadUUID: data?.['lead-uuid'],
      prevStep: data?.['prev-step'],
    },
    nome: {
      fullName: data?.data?.['full-name'],
      emailOptIn: data?.data?.['email-opt-in'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      flowName: data?.['flow-name'],
      leadUUID: data?.['lead-uuid'],
      prevStep: data?.['prev-step'],
    },
    email: {
      email: data?.data?.email,
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      flowName: data?.['flow-name'],
      leadUUID: data?.['lead-uuid'],
      prevStep: data?.['prev-step'],
    },
    celular: {
      cellphone: data?.data?.cellphone,
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      flowName: data?.['flow-name'],
      leadUUID: data?.['lead-uuid'],
      prevStep: data?.['prev-step'],
      whatsappOptIn: data?.data?.['whatsapp-opt-in'],
      whatsappFeatureEnabled: data?.data?.['whatsapp-feature-enabled'],
    },
    otp: {
      otpToken: data?.data?.['otp-token'],
      flowSize: data?.['flow-size'],
      stepIndex: data?.['step-index'],
      prevStep: data?.['prev-step'],
      whatsappOptIn: data?.data?.['whatsapp-opt-in'],
    },
    redirect: {
      leadName: helpers.string.getFirstWord(data?.data?.['full-name']),
      accountSegment: data?.data?.['account-segment'],
      deepLinkUrl: data?.data?.['deep-link-url'],
      isDeepLinkReady: data?.data?.['deep-link-ready'],
      flowName: data?.['flow-name'],
      leadUUID: data?.['lead-uuid'],
      prevStep: data?.['prev-step'],
      nextPage: data?.data?.['next-page'],
      intentSegmentAccount: data?.data?.['intent-account-segment'],
    },
  };

  return entitiesMapper?.[stepName];
};

export default {
  proposal,
  getProposal,
};
